import React from 'react';

import { createStyles, withStyles, Theme, FormControlLabel, Radio, RadioGroup, IconButton } from '@material-ui/core';
import { ArrowRight, ArrowLeft } from '@material-ui/icons';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import file from '../../../assets/excelFile.svg'
import commonStyles from '../../common/common.module.css';
import styles from '../analytics.module.css';

import TeamDetails from './TeamDetails';
import { Teams } from '../../../models/Analytics';

const NextArrow = (props: any) => {
  const { newClass, onClick } = props;
  return (
    <IconButton
      aria-label="Next"
      onClick={onClick}
      className={newClass}
      classes={{ root: styles.rightArrow }}
    >
      <ArrowRight
        color="primary" className={`${styles.rightArrowIcon}`}
      />
    </IconButton>
  );
};

const PrevArrow = (props: any) => {
  const { newClass, onClick } = props;
  return (
    <IconButton
      aria-label="Prev"
      onClick={onClick}
      className={newClass}
      classes={{ root: styles.leftArrow }}
    >
      <ArrowLeft
        color="primary" className={`${styles.leftArrowIcon}`}
      />
    </IconButton>
  );
};

const settings = {
  infinite: false,
  dots: false,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
  ]
};

const materialStyles = (theme: Theme) =>
  createStyles({

  });

interface CounterEfficiencyProps {
  type: string;
  sort: string;
  team: Teams[];
  handleChangeOption: (type: string, event: any) => void;
  handleExport: (type: string) => void;
};

const CounterEfficiency = (props: CounterEfficiencyProps) => {

  return (
    <div className={`${styles.wtOuterGridItems}`}>
      <div className={`${commonStyles.fSpaceBtw} ${commonStyles.flexWrap}`}>
        <h5 className={`${styles.heading} ${styles.teHeading}`}>{props.type == 'counter' ? 'Counter' : 'Warehouse'} Efficiency</h5>
        <RadioGroup
          row
          aria-label="Interval"
          name="Interval"
          onChange={(event) => props.handleChangeOption(props.type == 'counter' ? 'cSort' : 'wSort', event.target.value)}
          value={props.sort}
          className={`${styles.tcRadioGroup}`}>
          <small className={`${commonStyles.pr2}`}>Rank By:</small>
          <FormControlLabel
            value="awbs"
            control={
              <Radio
                color="primary"
                size="small"
              />
            }
            label='AWBS'
            className={styles.carrierRadio}
          />
          <FormControlLabel
            value={'orders'}
            control={
              <Radio
                color="primary"
                size="small"
              />
            }
            label="Orders"
            className={styles.carrierRadio}
          />
          <FormControlLabel
            value={'wgt'}
            control={
              <Radio
                color="primary"
                size="small"
              />
            }
            label="Actual Weight"
            className={styles.carrierRadio}
          />
          <FormControlLabel
            value={'pcs'}
            control={
              <Radio
                color="primary"
                size="small"
              />
            }
            label="Pieces"
            className={styles.carrierRadio}
          />
        </RadioGroup>
        <div className={`${styles.fileImg}`} onClick={() => props.handleExport(props.type)}>
          <img src={file} alt="file" />
        </div>
      </div>
      <div>
        <Slider {...settings} className={`${styles.slider}`}>
          {props.team && props.team.map((t: Teams, i: number) => {
            return (<TeamDetails
              type={props.type}
              pos={i + 1}
              name={t.name}
              orders={t.orders}
              pcs={t.pcs}
              wgts={t.wgt}
              awbs={t.awbs}
              payment={t.pick > 0 ? t.payment + '%' : 'NA'}
              docs={t.doc + '%'}
              waitlist={t.waitlist + '%'}
              screen={t.drop > 0 ? t.screen + '%' : 'NA'}
              dim={t.drop > 0 ? t.dim + '%' : 'NA'}
            />)
          })}
        </Slider>
      </div>
    </div>
  );
}

export default withStyles(materialStyles)(CounterEfficiency);
